const routes = {
  about: '/about',
  contact: '/contact',
  contactSuccess: '/contact/success',
  estate: '/estate',
  fund: '/fund',
  impressum: '/impressum',
  index: '/',
  indexDE: '/de',
  indexEN: '/en',
  indexPL: '/pl',
  investment: '/investments/:slug',
  investments: '/investments',
  jobs: '/jobs',
  page: '/page/:slug',
  policy: '/policy',
  press: '/press',
  pressSingle: '/press/:category',
  purchase: '/purchase',
  rent: '/rent',
  sale: '/sale',
  sponsorships: '/sponsorship',
  sponsorship: '/sponsorship/:slug',
  tenant: '/tenant',
}

export default routes
